import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import { NavHashLink as NavLink } from 'react-router-hash-link'
import Tooltip from 'rc-tooltip'
import 'rc-tooltip/assets/bootstrap_white.css'
import Loader from '../../components/Loader'
import { LanguageContext, LanguageConsumer } from '../../lib/LanguageContext'
import recordQuality from '../../images/record-quality.png'
import recordQualitySpec from '../../images/record-quality-spec.png'
import errorsType from '../../images/errors-type.png'
import errorsTypeSpec from '../../images/errors-type-spec.png'
import errorsField from '../../images/errors-field.png'
import errorsFieldSpec from '../../images/errors-field-spec.png'
import errorAnalysis from '../../images/error-analysis.png'
import filterNames from '../../images/filter-name.png'
import filterBirthDate from '../../images/filter-birthdate.png'
import filterMissmatch from '../../images/filter-missmatch.png'
import filterPills from '../../images/filter-pills.png'
import filterEnrollmentType from '../../images/filter-enrollment-type.png'
import postgraduateEnrollmentType from '../../images/postgraduate-enrollment-type.png'
import filteredResults from '../../images/filtered-results.png'
import results from '../../images/results.png'
import Footer from '../../Footer'
import '../Help.css'


class HelpEl extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: 'initial',
            transition: true
        }
    }

    componentWillMount() {
        this.setState(prevState => ({
            ...prevState,
            loading: false
        }))
    }

    componentDidMount() {
        let content = document.getElementById('content')
        if(content) {
            content.scrollTop = 0
        }
        document.title = this.context.polyglot.t('helpPageTitle')
        setTimeout(() => {
            this.setState(prevState => ({
                ...prevState,
                transition: false
            }))
        }, 10) 
    }
    
    render() {

        if (this.state.loading === 'true' || this.state.loading === 'initial') {
            return <Loader />
        }

        return(
         <LanguageConsumer>
          {({polyglot}) =>
          (<div className='Help-wrapper'>
             <div id='Help' className={`Help ${this.state.transition ? 'transition' : ''}`}>
                <div className='Help-content'>
                    <div id='introduction'>
                        <h2 className='helpHeader'>{polyglot.t('usersGuide')}</h2>

                        <div id='help-info'><p>Στα πλαίσια των ποιοτικών ελέγχων δεδομένων που περιέχονται στα μητρώα φοιτητών των ιδρυμάτων, αναπτύχθηκε
                        η διαδικτυακή εφαρμογή Identify.</p>

                        <p>Η εφαρμογή αυτή δίνει τη δυνατότητα στο προσωπικό των ιδρυμάτων να ενημερωθεί εύκολα και άμεσα, για την
                        ποιότητα των δεδομένων και τις αποκλίσεις που βρέθηκαν σε αυτά.</p>

                        <p>Συγκεκριμένα, μετά την σύνδεση στο Identify, ο εξουσιοδοτημένος χρήστης μπορεί να ενημερωθεί μέσω
                        γραφημάτων για τα στατιστικά (<Link to='/overview'>Στατιστικά</Link>) των αποκλίσεων στα δεδομένα. Συγκεκριμένα, παρέχεται ενημέρωση
                        σχετικά με:</p></div>
                        </div>
                    <div id='record-quality'>
                        <h3 className='header'>Την Ποιότητα Εγγραφών</h3>
                        <p>Οι εγγραφές με βάση την σοβαρότητα των αποκλίσεων που εντοπίστηκαν σε αυτές χωρίζονται σε 6 κατηγορίες: </p>

                        <ul>
                            <li>Χωρίς Αποκλίσεις</li>
                            <li>Με Πολύ Χαμηλής Σοβαρότητας Αποκλίσεις</li>
                            <li>Με Χαμηλής Σοβαρότητας Αποκλίσεις</li>
                            <li>Με Μέτριας Σοβαρότητας Αποκλίσεις</li>
                            <li>Με Αρκετά Σοβαρές Αποκλίσεις</li>
                            <li>Με Πολύ Σοβαρές Αποκλίσεις</li>
                        </ul>

                        <img src={recordQuality} alt="record-quality"/>

                        <p>Επιλέγοντας μια κατηγορία είτε από το διάγραμμα είτε από το υπόμνημα, ο χρήστης μπορεί να πληροφορηθεί για το ποιες αποκλίσεις κατέταξαν ένα συγκεκριμένο ποσοστό εγγραφών σε αυτή.</p>

                        <img src={recordQualitySpec} alt="record-quality-spec"/>
                    </div>
                    <div id='errors-per-type'>
                        <h3 className='header'>Τις Αποκλίσεις ανά Είδος</h3>
                        <p>Οι αποκλίσεις που βρέθηκαν ομαδοποιούνται με βάση το είδος τους το οποίο μπορεί να είναι ένα από τα παρακάτω:</p>

                        <ul>
                            <li>Κενή Τιμή</li>
                            <li>Μη Έγκυρη Μορφή</li>
                            <li>Μη Έγκυρη Τιμή</li>
                            <li>Κανονικοποίηση Δεδομένων</li>
                            <li>Κενοί Χαρακτήρες</li>
                            <li>Ασυμφωνία (με τα στοιχεία Εθνικών Μητρώων)</li>
                        </ul>

                        <img src={errorsType} alt="errors-type" />

                        <p> Επιλέγοντας μια κατηγορία είτε από το διάγραμμα είτε από το υπόμνημα, ο χρήστης μπορεί να πληροφορηθεί, μέσω νέου γραφήματος, για τα ποσοστά των συγκεκριμένων αποκλίσεων που βρέθηκαν να ανήκουν σε αυτή.</p>
                        
                        <img src={errorsTypeSpec} alt="errors-type-spec" />
                    </div>
                    <div id='errors-per-field'>
                        <h3 className='header'>Τις Αποκλίσεις ανά Πεδίο</h3>
                        <p>Οι αποκλίσεις που βρέθηκαν ομαδοποιούνται με βάση το πεδίο του μητρώου φοιτητών το οποίο αφορούν.</p>

                        <img src={errorsField} alt="errors-field" />

                        <p> Επιλέγοντας ένα πεδίο είτε από το διάγραμμα είτε από το υπόμνημα, ο χρήστης μπορεί να πληροφορηθεί μέσω νέου γραφήματος, για τα ποσοστά των συγκεκριμένων αποκλίσεων που βρέθηκαν να το αφορούν.</p>

                        <img src={errorsFieldSpec} alt="errors-type-spec" />

                    </div>
                    <div id='error-analysis'>
                        <h3 className='header'>Την Ανάλυση Αποκλίσεων</h3>
                        <p>Παρουσιάζονται αναλυτικά οι αποκλίσεις που βρέθηκαν αναξαρτήτως πεδίου ή είδους.</p>

                        <img src={errorAnalysis} alt="error-analysis" />

                        <p>Τα παραπάνω αποτελέσματα μπορούν να αφορούν όλο το ίδρυμα, ή να προσαρμοστούν με βάση το τμήμα που θα επιλέξει ο χρήστης.</p>
                    
                        <p>Σε όλα τα γραφήματα, δίνεται το ποσοστό της κάθε κατηγορίας, μεταφέροντας τον κέρσορα πάνω από το υπόμνημα ή το γράφημα, δίνεται και ο αριθμός του αντίστοιχου πλήθους πάνω στο γράφημα.</p>
                    </div>
                    <div id='results'>
                        <h3 className='header'>Αναλυτικά Αποτελέσματα</h3>
                        <p>Η εφαρμογή δίνει την δυνατότητα προβολής των αναλυτικών <Link to='/results'>Αποτελεσμάτων</Link> που προέκυψαν από τον τελευταίο έλεγχο στο πληροφοριακό σύστημα του Ιδρύματος.</p>
                        <p>Τα αποτελέσματα αυτά παρουσιάζουν τις εγγραφές στις οποίες το Identify εντόπισε αποκλίσεις σε μορφή λίστας, ενώ ο εξουσιοδοτημένος χρήστης έχει τη δυνατότητα να τα ταξινομήσει και να τα φιλτράρει με βάση χαρακτηριστικά των αποκλίσεων και πεδία της βάσης του συστήματος που επιθυμεί.</p>
                        <p>Τα στοιχεία με τα οποία ο χρήστης μπορεί να πραγματοποιήσει αναζητήσεις πάνω στο σύνολο των αποτελεσμάτων είναι το εξής:
                        </p>
                        <div id='filtering-attr'>
                            <h3>Σχετικά με τις αποκλίσεις</h3>
                            <ul>
                                <li>Πεδία που σχετίζονται με αποκλίσεις που βρέθηκαν</li>
                                <li>Είδη αποκλίσεων που βρέθηκαν</li>
                                <li>Σοβαρότητα αποκλίσεων εγγραφής</li>
                            </ul>

                            <h3>Σχετικά με την εγγραφή</h3>
                            <h4>Αναγνωριστικά</h4>
                            <ul>
                                <li>Registration Id</li>
                                <li>System Id</li>
                                <li>ΑΜΚΑ</li>
                                <li>Χώρα έκδοσης ΑΜΚΑ</li>
                                <li>ΑΦΜ</li>
                                <li>Χώρα έκδοσης ΑΦΜ</li>
                            </ul>
                            <h4>Ονοματεπωνυμικά</h4>
                            <ul>
                                <li>Επίθετο στα Ελληνικά</li>
                                <li>Επίθετο στα Λατινικά</li>
                                <li>Όνομα στα Ελληνικά</li>
                                <li>Όνομα στα Λατινικά</li>
                                <li>Όνομα Πατρός στα Ελληνικά</li>
                                <li>Όνομα Πατρός στα Λατινικά</li>
                                <li>Όνομα Μητρός στα Ελληνικά</li>
                                <li>Όνομα Μητρός στα Λατινικά</li>
                            </ul>
                            <h4>Σπουδές</h4>
                            <ul>
                                <li>Τμήμα</li>
                                <li>Τύπος Εγγραφής</li>
                                <li>Σπουδαστική Κατάσταση</li>
                                <li>Ημερομηνία Μεταβολής Σπουδαστικής Κατάστασης</li>
                                <li>Σπουδαστικό Εξάμηνο</li>
                            </ul>
                            <h4>Λογαριασμός</h4>
                            <ul>
                                <li>Όνομα χρήστη</li>
                                <li>Κατάσταση Λογαριασμού</li>
                            </ul>
                            <h4>Επικοινωνία</h4>
                            <ul>
                                <li>Διεύθυνση Ηλεκτρονικού Ταχυδρομείου</li>
                                <li>Αριθμός Κινητού Τηλεφώνου</li>
                            </ul>
                            <h4>Προσωπικά Στοιχεία</h4>
                            <ul>
                                <li>Ημερομηνία Γέννησης</li>
                                <li>Έτος Γέννησης</li>
                                <li>Φύλο</li>
                                <li>Υπηκοότητα</li>
                            </ul>
                        </div>
                        <p>Ο χρήστης έχει τη δυνατότητα να επιλέξει οποιαδήποτε από τις εγγραφές που βρέθηκαν να περιέχουν αποκλίσεις και να ενημερωθεί για τα στοιχεία της και τα στοιχεία των αποκλίσεων της.</p>
                        <div className='result-example'>
                            <h3>Παράδειγμα Αναζήτησης</h3>
                            <p>Στο συγκεκριμένο παράδειγμα θα παρουσιάσουμε την περίπτωση όπου ο εξουσιοδοτημένος χρήστης του Identify θέλει να πραγματοποιήσει μια αναζήτηση πάνω στα αποτελέσματα, ώστε να δει ποιες εγγραφές έχουν τα εξής χαρακτηριστικά:</p>
                              <ul>
                                  <li>Είναι φοιτητές <span className='underline'>μεταπτυχιακού</span> προγράμματος σπουδών</li>
                                  <li>Εμφανίζουν ασυμφωνία μεταξύ πληροφοριακού συστήματος και μητρώου ΑΜΚΑ στο <span className='underline'>Όνομα στα Ελληνικά</span></li>
                                  <li>Εμφανίζουν ασυμφωνία μεταξύ πληροφοριακού συστήματος και μητρώου ΑΜΚΑ στο <span className='underline'>Επίθετο στα Ελληνικά</span></li>
                                  <li>Εμφανίζουν ασυμφωνία μεταξύ πληροφοριακού συστήματος και μητρώου ΑΜΚΑ στην <span className='underline'>ημερομηνία γέννησης</span></li>
                              </ul>
                              <p>Ο χρήστης, από τα <em>Φίλτρα</em> αναζήτησης θα επιλέξει τα <em>πεδία</em> που σχετίζονται με τις αποκλίσεις που τον ενδιαφέρουν. Στην προκειμένη περίπτωση αυτές είναι: <span className='underline'>όνομα στα ελληνικά</span>, <span className='underline'>επίθετο στα ελληνικά</span> και <span className='underline'>ημερομηνία γέννησης</span>.</p>
                              <span className='image-group'>
                                  <img className='smaller' id='filter-name' src={filterNames} alt='filter-by-names'/>
                                  <img className='smaller' id='filter-birthdate' src={filterBirthDate} alt='filter-by-birthdate'/>
                              </span>
                              <p>Έπειτα ο χρήστης, θα επιλέξει από τα <em>είδη</em> αποκλίσεων την "Ασυμφωνία", που είναι το μόνο είδος απόκλισης που φαίνεται να τον ενδιαφέρει σε αυτή την περίπτωση.</p>
                              <span className='image-group'>
                                  <img className='smaller' id='filter-missmatch' src={filterMissmatch} alt='filter-missmatch'/>
                              </span>
                              <p>Τέλος, ο χρήστης επιθυμεί να περιορίσει τυχόν αποτελέσματα μόνο στους <span className='underline'>μεταπτυχιακούς</span> φοιτητές, οπότε συμπληρώνει το πεδίο Τύπος Εγγραφής με "postgraduate".</p>
                              <span className='image-group'>
                                  <img className='smaller' id='filter-enrollment-type' src={filterEnrollmentType} alt='filter-by-enrollnent-type'/>
                                  <img className='smaller' id='selected-postgraduate' src={postgraduateEnrollmentType} alt='selected-postgraduate-enrollment-type'/>
                              </span>
                             <p>Μετά την παραπάνω διαδικασία ο χρήστης έχει τη δυνατότητα να δει και να ταξινομήσει τις εγγραφές που  συμφωνούν με τους περιορισμούς που έθεσε.</p>
                              <p>Ο χρήστης στη συνέχεια επιλέγει "Συνέχεια" ώστε τα φίλτρα να προσαρμοστούν στο σύνολο των αποτελεσμάτων ή "Ακύρωση" σε περίπτωση που άλλαξε γνώμη για τις τελευταίες του αλλαγές πάνω σε αυτά.</p>
                              <p>Όλα τα φίλτρα που έχουν επιλεχθεί από τον χρήστη και έπειτα χρησιμοποιηθεί στην αναζήτηση των αποτελεσμάτων είναι ορατά με την παρακάτω μορφή: </p>
                              <span className='image-group'>
                                  <img className='smaller' id='filter-pills' src={filterPills} alt='filter-pills'/>
                              </span>
                              <p>Τα φιλτραρισμένα αποτελέσματα εμφανίζονται στον χρήστη με την παρακάτω μορφή: </p>
                              <span className='image-group'>
                                  <img className='smaller' id='filtered-results' src={filteredResults}/>
                              </span>
                              <p>Τέλος ο  χρήστης μπορεί να επιλέξει οποιαδήποτε εγγραφή από τα παραπάνω αποτελέσματα και να μάθει αναλυτικές πληροφορίες σχετικά με τις αποκλίσεις της.</p>
                        </div>

                    </div>
                    <div id='authorization'>
                        <h3 className='header'>Πρόσβαση στην Eφαρμογή</h3>
                        <p>Η πρόσβαση στην εφαρμογή παρέχεται με username / password που αποδίδεται κατόπιν αιτήματος. Στην παρούσα φάση ο λογαριασμός είναι κοινός για το σύνολο των τμημάτων ενός ιδρύματος. Η αίτηση απόδοσης λογαριασμού γίνεται με την αποστολή email:</p>

                        <div className='mail-example'>
                            <p><span className='mail-to'>Προς:</span><Tooltip placement="bottom" trigger={['hover']} mouseEnterDelay={0.1} mouseLeaveDelay={0.1} overlay={<span>{polyglot.t('clickToMail')}</span>}><span><a href='mailto:info@gunet.gr'> info@gunet.gr</a> <i className="far fa-envelope"></i></span></Tooltip></p>
                            <p><span className='mail-to'>Θέμα:</span><Tooltip placement="bottom" trigger={['hover']} mouseEnterDelay={0.1} mouseLeaveDelay={0.1} overlay={<span>{polyglot.t('clickToCopy')}</span>}><span><CopyToClipboard text={polyglot.t('accessMailSubject')}><span className='copyToClip'> {polyglot.t('accessMailSubject')}</span></CopyToClipboard> <i className="far fa-copy"></i></span></Tooltip></p>
                        </div>
                    </div>
                    <div id='run-scheduling'>
                        <h3 className='header'>Προγραμματισμός Νέων Ελέγχων</h3>
                        <p>
                            Ο προγραμματισμός νέων ελέγχων για την επικαιροποίηση των αποτελεσμάτων π.χ. μετά από διορθώσεις στο μητρώο φοιτητών, γίνεται κατόπιν αιτήματος με την αποστολή email:
                        </p>

                        <div className='mail-example'>
                            <p><span className='mail-to'>Προς:</span><Tooltip placement="bottom" trigger={['hover']} mouseEnterDelay={0.1} mouseLeaveDelay={0.1} overlay={<span>{polyglot.t('clickToMail')}</span>}><span><a href='mailto:info@gunet.gr'> info@gunet.gr</a> <i className="far fa-envelope"></i></span></Tooltip></p>
                            <p><span className='mail-to'>Θέμα:</span><Tooltip placement="bottom" trigger={['hover']} mouseEnterDelay={0.1} mouseLeaveDelay={0.1} overlay={<span>{polyglot.t('clickToCopy')}</span>}><span><CopyToClipboard text={polyglot.t('runRequestMailSubject')}><span className='copyToClip'> {polyglot.t('runRequestMailSubject')}</span></CopyToClipboard> <i className="far fa-copy"></i></span></Tooltip></p>
                            <span className='mail-to'>Κείμενο Μηνύματος:</span>
                            <p className='email-body'>{polyglot.t('runRequestMailBody')}</p>
                            <p className='email-body'><span className='sqlCode'><i>{polyglot.t('runRequestMailClause1')}</i></span> ή <i><span className='sqlCode'>{polyglot.t('runRequestMailClause2')}</span></i></p>
                        </div>

                        <p>
                            Οι παραπάνω αιτήσεις γίνονται δεκτές μόνο από προσωπικό του ιδρύματος που έχει δηλωθεί στο GUnet είτε ως Υπεύθυνος Διαχειριστής είτε ως Προϊστάμενος της μονάδας που διαχειρίζεται το πληροφοριακό σύστημα Ηλεκτρονικής Γραμματείας.  Πληροφορίες για το προσωπικό που έχει δηλωθεί από κάθε ίδρυμα, για την Ηλεκτρονική Γραμματεία είναι διαθέσιμες από την κα. Ευγενία Στεφανίδου στο τηλ. <span className='telephone'>210 727 5611</span>.
                        </p>
                    </div>
                    <div id='requirements'>
                        <div><h3 className='header'>Προϋποθέσεις</h3>
                            <p>
                        Προϋπόθεση για την ένταξη ενός ιδρύματος στον μηχανισμό παρακολούθησης της ποιότητας δεδομένων του μητρώου Φοιτητών, είναι να έχει κατασκευάσει το GUnet IDM SIS DB View (<a href='https://synergasia.gunet.gr/modules/document/file.php/EOE105/Identity_GUnet_SIS_DB_View_Definitions_v2.1.pdf'>https://synergasia.gunet.gr/modules/document/file.php/EOE105/Identity_GUnet_SIS_DB_View_Definitions_v2.1.pdf</a>) και να έχει σε αυτό πρόσβαση η εφαρμογή Identify. </p>
                        </div>
                    </div>
                </div>
                <div className={`Help-nav ${this.props.helpNavState === 'bottom' ? 'bottom' : ''}`}>
                    <div className='nav-content'>
                        <h4 className='header'>{polyglot.t('helpContents')}</h4>
                        <ul className='content-list'>
                            <li>
                                <NavLink to="/help#introduction" activeClassName='nav-active'>{polyglot.t('helpIntroduction')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="/help#record-quality" activeClassName='nav-active'>{polyglot.t('helpRecordQuality')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="/help#errors-per-type" activeClassName='nav-active'>{polyglot.t('helpErrorsPerType')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="/help#errors-per-field" activeClassName='nav-active'>{polyglot.t('helpErrorsPerField')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="/help#error-analysis" activeClassName='nav-active'>{polyglot.t('helpErrorAnalysis')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="help#results" activeClassName='nav-active'>{polyglot.t('helpResults')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="help#authorization" activeClassName='nav-active'>{polyglot.t('helpAuthorization')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="help#run-scheduling" activeClassName='nav-active'>{polyglot.t('helpRunScheduling')}</NavLink>
                            </li>
                            <li>
                                <NavLink to="help#requirements" activeClassName='nav-active'>{polyglot.t('helpRequirements')}</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>)}
      </LanguageConsumer>
      )
    }
}
HelpEl.contextType = LanguageContext

export default HelpEl



// WEBPACK FOOTER //
// ./src/help/el/HelpEl.js